import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';

export const payoutPayoutDetailsParameter = 'payout' as const;
export const inlinePayoutDetailsParameter = 'inline' as const;

const payoutDetailsParams = [
  payoutPayoutDetailsParameter,
  inlinePayoutDetailsParameter,
] as const;
type PayoutDetailsParams = (typeof payoutDetailsParams)[number];
export type PayoutDetailsHtmlParams = Partial<
  Record<PayoutDetailsParams, string>
>;

export const PayoutDetailsConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "payoutDetails" */ '../../../components/Payouts/PayoutDetails'
    ),
  htmlAttributes: {
    [payoutPayoutDetailsParameter]: {
      isInternal: false,
    },
    // Internal - for docs site
    [inlinePayoutDetailsParameter]: {
      isInternal: false,
    },
  },
  htmlEvents: ['close'],
  customHtmlElementMethods: {
    setPayout: {
      type: 'AttributeSettingMethod',
      attribute: payoutPayoutDetailsParameter,
      isInternal: false,
      description: 'Sets the payout id to display details for.',
    },
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: false,
      description:
        'Sets the event listener for when the payout details overlay is closed',
    },
    // Internal - for docs site
    setInline: {
      type: 'AttributeSettingMethod',
      attribute: inlinePayoutDetailsParameter,
      isInternal: true,
      description:
        'Sets whether the payout details should be displayed inline or in an overlay.',
    },
  },
  enabledKey: 'payout_details',
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: 'Shows details for a given payout.',
  optionalInlineOverlay: true,
  friendlyName: 'Payout details',
  releaseState: 'ga',
  enabledOverrideFlag: 'enable_payout_details_component',
};
